module.exports = __webpack_public_path__ + "img/Pedale-Referencia-de-Aro-por-Idade.b7b43851.jpg";